import React, { useState } from 'react';
import NavItem from './NavItem';
import { ReactComponent as IconDrop } from '../../Icons/Exp_Sidebar/Drop.svg';
import { ReactComponent as IconImaging } from '../../Icons/Exp_Sidebar/Imaging.svg';
import { ReactComponent as IconImagingTools } from '../../Icons/Exp_Sidebar/ImagingTools.svg';
import { RMHelpURL, RMLiteHelpURL } from 'utils/Global';
import { useRMSelector } from 'redux/hooks';
import { selectProductEdition } from 'redux/selectors/StateSelectors';
import NotificationsPanel from './NotificationsPanel';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { EProductEditions } from 'enums/EProductEditions';
import {
  useSelectedDropImageParameters,
  useLastSelectedWellNavigationDetails,
} from 'redux/hooks/experiment';
import useRMLite from 'CustomHooks/useRMLite';
const iconColor = '#ffffff';
const ExperimentSidebar = ({ to }: any) => {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { wellNum, plateID } = wellNavigationDetails || {};
  const { inspection, cpId, dropNumber, regionName } = selectedDropImageParameters || {};
  const imageBatchId = inspection?.groupedInspections?.find(
    (gi) => gi.plateId === plateID,
  )?.imageBatchId;
  const exp = useRMSelector(selectExp);
  const rmLite = useRMLite();
  const DESIGN = 'DESIGN';
  const IMAGES = 'IMAGES';
  const SCORE = 'SCORE';
  const COMPARE = 'COMPARE';
  const HELPANDSUPPORT = 'HELPANDSUPPORT';
  const DROP = 'DROP';
  const [openedNavItem, setOpenedNavItem] = useState({ value: DESIGN });
  const productEdition = useRMSelector(selectProductEdition);
  const isImagesOpen = openedNavItem.value === IMAGES;
  const extendBorder = '4px solid #F7A246';

  const onNavItemClick = (navItemId) => {
    if (openedNavItem.value === navItemId) {
      setOpenedNavItem({ value: null });
    } else {
      setOpenedNavItem({ value: navItemId });
    }
    if (navItemId === 'HELPANDSUPPORT') {
      window.open(rmLite ? RMLiteHelpURL : RMHelpURL, 'webhelp');
    }
  };

  const imageMenu = [
    <NavItem 
      label="Imaging"
      key="imaging"
      to={`/exp/${to}`}
      icon={<IconImaging  id='experimentsidebar-imaging'/>}
      activeClass=""
      style={{ borderTop: extendBorder }}
    />,
    <NavItem
      label="Image Tools"
      key="imagetools"
      to="/harvestxtals"
      icon={<IconImagingTools id='experimentsidebar-imagetools-icon' />}
      activeClass=""
      style={{ borderBottom: extendBorder }}
    />,
  ];
  return (
    <div id='experimentsidebar-wrapper' className="sidebar border-sidebar h-100">
      <NotificationsPanel key={'user'} />
      <NavItem
        to={`/exp/${to}/info`}
        label="Info"
        key="experiment_info"
        icon={<RMSvgIcon id='experimentsidebar-experiementinfo-icon' name="ExperimentInfo" fill={iconColor} />}
        onClick={() => onNavItemClick(DESIGN)}
      />
      <NavItem
        to={`/exp/${to}`}
        label="Canvas"
        key="canvas"
        icon={<RMSvgIcon id='experimentsidebar-canvas-icon' name="Canvas" fill={iconColor} />}
        onClick={() => onNavItemClick(DESIGN)}
      />
      {isImagesOpen ? imageMenu : null}
      {!rmLite && (
        <NavItem
          to={`/exp/${to}/${plateID === undefined ? null : plateID}/${
            wellNum === undefined ? null : wellNum
          }/${dropNumber === undefined ? null : dropNumber}/${
            cpId === undefined ? null : cpId
          }/${regionName === undefined ? null : regionName}/${imageBatchId}/well`}
          isDisabled={
            !exp?.isImageModeActive === true ||
            productEdition === EProductEditions.ExperimentDesigner ||
            !(wellNavigationDetails && selectedDropImageParameters)
          }
          label="Well"
          key="well"
          icon={<RMSvgIcon id='experimentsidebar-well-icon' name="Well" fill={iconColor} />}
          onClick={() => onNavItemClick(SCORE)}
        />
      )}
      <NavItem
        to={`/exp/${to}/${plateID === undefined ? null : plateID}/${
          wellNum === undefined ? null : wellNum
        }/${dropNumber === undefined ? null : dropNumber}/${
          cpId === undefined ? null : cpId
        }/${regionName === undefined ? null : regionName}/${imageBatchId}/drop`}
        label="Drop"
        key="drop"
        icon={<IconDrop id='experimentsidebar-drop-icon' />}
        onClick={() => onNavItemClick(DROP)}
        isDisabled={
          !exp?.isImageModeActive === true ||
          (productEdition === EProductEditions.ExperimentDesigner && !rmLite) ||
          !(wellNavigationDetails && selectedDropImageParameters)
        }
      />
      <NavItem
        to={`/exp/${to}/${plateID === undefined ? null : plateID}/${
          wellNum === undefined ? null : wellNum
        }/${dropNumber === undefined ? null : dropNumber}/${
          cpId === undefined ? null : cpId
        }/${regionName === undefined ? null : regionName}/${
          imageBatchId === undefined ? null : imageBatchId
        }/compare`}
        label="Compare"
        key="compare"
        icon={<RMSvgIcon id='experimentsidebar-compare-icon' name="Compare" fill={iconColor} />}
        onClick={() => onNavItemClick(COMPARE)}
        isDisabled={
          !exp?.isImageModeActive === true ||
          productEdition === EProductEditions.ExperimentDesigner ||
          !(wellNavigationDetails && selectedDropImageParameters)
        }
      />
      <NavItem
        to={`/exp/${to}/?help`}
        label="Help"
        key="help"
        icon={<RMSvgIcon id='experimentsidebar-help-icon' name="Help" fill={iconColor} />}
        onClick={() => onNavItemClick(HELPANDSUPPORT)}
      />
    </div>
  );
};

export default ExperimentSidebar;
